const purchase_analytics = '@@purchase_analytics/'
export const TRACK_PURCHASE_UI = `${purchase_analytics}TRACK_PURCHASE_UI`;
export const TRACKED = `${purchase_analytics}TRACKED`
